import React from 'react'
import SbEditable from 'storyblok-react'
import { AccordionItem, Accordion } from '@/components/ui/accordion'
import RichText from '@/utils/RichText'
import Heading from '@/components/Heading'
import { AccordionItemStoryblok, AccordionStoryblok } from '@/components/component-types-sb'

interface SbAccordionItemType extends AccordionItemStoryblok{
  title: string
}

export const Accordion2Block = ({ blok }: AccordionStoryblok) => {
  const marginTopClass = blok.marginTop ? `${blok.marginTop}px` : ''
  const marginBottomClass = blok.marginBottom ? `${blok.marginBottom}px` : ''

  return (
    /** @ts-ignore: Storyblok typing issue with children */
    <SbEditable content={blok} key={blok._uid}>
        <div
          data-testid="accordion-2-container"
          className="flex flex-col max-w-5xl items-center mx-auto px-4 gap-6 justify-center text-darkblue font-display md:px-6 md:items-start lg:justify-start lg:px-8 lg:flex-row "
          style={{ 
            marginTop: marginTopClass,
            marginBottom: marginBottomClass 
          }}
        >
          {/*@INFO: Header section with flexible layout */}
          <div className="flex flex-col gap-8 md:flex-row md:justify-between md:items-start lg:flex-col">
            {/*@INFO: Text content */}
            <div className="space-y-2 pt-4">
              {blok.title && (
                <Heading size="h2" className="!text-[40px] !leading-[44px] lg:!text-[48px] lg:!leading-[53px] lg:max-w-[400px] font-bold">
                  <RichText>{blok.title}</RichText>
                </Heading>
              )}
            </div>
          </div>

          {/*@INFO: Main content section */}
            {/*@INFO: Accordion section */}
            <div className="lg:w-1/2 font-display">
              <Accordion
                defaultOpenId={blok.items[0]?._uid || ''}
              >
                {blok.items.map((item: SbAccordionItemType) => (
                  <AccordionItem
                    key={item._uid}
                    id={item._uid}
                    title={item.title}
                  >
                    <RichText>{item.description}</RichText>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
      </div>
    </SbEditable>
  )
}

Accordion2Block.displayName = 'Accordion2 Block'